import { render } from "./StepCguv.vue?vue&type=template&id=16d468c4"
import script from "./StepCguv.vue?vue&type=script&lang=js"
export * from "./StepCguv.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__